import {
  FETCH_USERS,
  FETCH_CONTROLLERS,
  FE,
  FETCH_USER_CONTROLLERS,
  UPDATE_OTA,
  ADD_CONTROLLER,
  UPDATE_CONTROLLER,
  FETCH_INVOICE,
  FACTORY_RESET,
} from "./types";

const fetchUsersAction = () => ({
  type: FETCH_USERS,
});

const fetchControllerAction = () => ({
  type: FETCH_CONTROLLERS,
});

const fetchUserControllerAction = () => ({
  type: FETCH_USER_CONTROLLERS,
});

const updateOtaAction = ({ payload }) => ({
  type: UPDATE_OTA,
  payload,
});

const addControllerAction = ({ payload }) => ({
  type: ADD_CONTROLLER,
  payload,
});

const updateControllerAction = ({ payload }) => ({
  type: UPDATE_CONTROLLER,
  payload,
});

const fetchInvoiceAction = () => ({
  type: FETCH_INVOICE,
});

const factoryResetAction = ({ payload }) => ({
  type: FACTORY_RESET,
  payload,
});

export {
  fetchUsersAction,
  fetchControllerAction,
  fetchUserControllerAction,
  updateOtaAction,
  addControllerAction,
  updateControllerAction,
  fetchInvoiceAction,
  factoryResetAction,
};
